import React from "react";
import "./BoardChip.scss";

const BoardChip = ({
  children,
  active = false,
  onClick,
  className = "",
}) => {
  const classes = [
    "pb-chip",
    active ? "pb-chip--active" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const Tag = onClick ? "button" : "span";

  return (
    <Tag
      type={onClick ? "button" : undefined}
      className={classes}
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};

export default BoardChip;
